import { call, put } from 'redux-saga/effects';

import request from './request';
import {
  fetchDailyReportsFailed,
  fetchDailyReportsRequested,
  fetchDailyReportsSucceeded,
  fetchMonthlyReportsFailed,
  fetchMonthlyReportsRequested,
  fetchMonthlyReportsSucceeded,
  fetchYearlyReportsFailed,
  fetchYearlyReportsRequested,
  fetchYearlyReportsSucceeded,
} from '../../../actions';
import api from '../../../api';

// eslint-disable-next-line import/prefer-default-export
/* Daily Reports */
export function* fetchDailyReportsRequest(currentDay, interval) {
  yield put(fetchDailyReportsRequested(currentDay, interval));

  try {
    const reportsValue = yield call(request, api.getDailyReports, currentDay, interval);
    const action = fetchDailyReportsSucceeded(reportsValue);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = fetchDailyReportsFailed(error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}

/* Monthly Reports */
export function* fetchMonthlyReportsRequest(currentMonth) {
  yield put(fetchMonthlyReportsRequested(currentMonth));

  try {
    const reportsValue = yield call(request, api.getMonthlyReports, currentMonth);

    const action = fetchMonthlyReportsSucceeded(reportsValue);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = fetchMonthlyReportsFailed(error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}

/* Yearly Reports */
export function* fetchYearlyReportsRequest(currentYear) {
  yield put(fetchYearlyReportsRequested(currentYear));

  try {
    const reportsValue = yield call(request, api.getYearlyReports, currentYear);

    const action = fetchYearlyReportsSucceeded(reportsValue);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = fetchYearlyReportsFailed(error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}
